import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'academicYearSplit',
})
export class academicYearSplitPipe implements PipeTransform {
  transform(text: string, by = ' ', index = 1) {
    const arr = text.split(by);
    return arr[index];
  }
}
